/**
 * EmployeeStatsCards Component
 * Displays statistics cards for employees
 */
import { Card } from '../ui/card';
import { Users, CheckCircle2, AlertCircle, Briefcase } from 'lucide-react';

const StatCard = ({ icon: Icon, iconBgColor, iconColor, label, value }) => (
  <Card className="p-4">
    <div className="flex items-center gap-3">
      <div className={`${iconBgColor} p-3 rounded-lg`}>
        <Icon size={24} className={iconColor} />
      </div>
      <div>
        <p className="text-xs font-bold uppercase text-slate-500">{label}</p>
        <p className="text-2xl font-bold">{value}</p>
      </div>
    </div>
  </Card>
);

const EmployeeStatsCards = ({ employees }) => {
  const totalEmployees = employees.length;
  const activeEmployees = employees.filter(e => e.status === 'ativo').length;
  const inactiveEmployees = employees.filter(e => e.status !== 'ativo').length;
  const sectorsCount = new Set(employees.map(e => e.setor).filter(Boolean)).size;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-testid="employee-stats">
      <StatCard
        icon={Users}
        iconBgColor="bg-blue-100 dark:bg-blue-900"
        iconColor="text-blue-600"
        label="Total"
        value={totalEmployees}
      />
      <StatCard
        icon={CheckCircle2}
        iconBgColor="bg-emerald-100 dark:bg-emerald-900"
        iconColor="text-emerald-600"
        label="Ativos"
        value={activeEmployees}
      />
      <StatCard
        icon={AlertCircle}
        iconBgColor="bg-amber-100 dark:bg-amber-900"
        iconColor="text-amber-600"
        label="Inativos"
        value={inactiveEmployees}
      />
      <StatCard
        icon={Briefcase}
        iconBgColor="bg-purple-100 dark:bg-purple-900"
        iconColor="text-purple-600"
        label="Setores"
        value={sectorsCount}
      />
    </div>
  );
};

export default EmployeeStatsCards;
